import { LOADER_PHASES } from '../utils';
import { Pane, Text } from 'evergreen-ui';
import styled from 'styled-components';
import SearchToggle from './SearchToggle';
import ShiftsListItem from './ShiftsListItem';
import SmallLoader from './SmallLoader';

export const StyledList = styled(Pane)`
  display: flex;
  flex-direction: column;
  position: absolute;
  overflow: auto;
  max-height: calc(100% - 134px);
  width: 100%;
  margin-top: 134px;
  padding-top: 10px;
  padding-bottom: 60px;
`;

const StyledListControls = styled(Pane)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  z-index: 3;
  margin: 30px 20px 0;
`;
const ShiftsList = ({ items, phase = LOADER_PHASES.PAUSED, toggleSearch, isLinked }) => {
  return (
    <Pane background="#1F2021" position="relative" display="flex" flex={1} height="100%" flexDirection="column">
      <StyledListControls>
        <SmallLoader phase={phase} isLinked={isLinked} />
        <SearchToggle phase={phase} onClick={toggleSearch} isLinked={isLinked} />
      </StyledListControls>
      <Text
        color="#A7AAAC"
        background="#1F2021"
        fontSize={14}
        fontWeight={500}
        paddingX={20}
        paddingTop={30}
        paddingBottom={10}
        boxShadow="0 0 14px 12px #1F2021"
        textTransform="uppercase"
        marginBottom={15}
        zIndex={2}
      >
        {items.length} upcoming shifts:
      </Text>
      <StyledList>
        {items.map((item, key) => (
          <ShiftsListItem item={item} key={key} />
        ))}
      </StyledList>
      <Pane
        position="absolute"
        bottom={-12}
        height={0}
        width="100%"
        boxShadow="0 0 14px 22px #1F2021"
        background="#1F2021"
      />
    </Pane>
  );
};

export default ShiftsList;
